/****************************************************
 * Module Name:  help.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import { Box, Card, CardContent, CardHeader, Paper, Typography } from "@mui/material";
import React, { Component } from "react";
import { SiGmail } from 'react-icons/si'
import { FaBook } from "react-icons/fa";
import { HiOutlineCodeBracket } from "react-icons/hi2";
import { FcOnlineSupport } from "react-icons/fc";
import Constants from "../../utility/constants";
import PageTitle from "../common/pageTitle";

export class Help extends Component {

  componentDidMount() {
    PageTitle("HELP");
  }

  render() {
    return (
      <Box width={'100%'} style={{ backgroundColor: '#f4f4f4', height: '100vh', display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
        <Box display={'flex'} flexDirection={'column'} alignSelf={'flex-start'} >
          <Box display={'flex'} width={'100%'} alignItems='center'>
            <FcOnlineSupport size={80} style={{ marginRight: 10 }} />
            <Typography fontSize={80}>
              HELP CENTER
            </Typography>
          </Box>
          <hr />
          <Box pt={5} display={'flex'} justifyContent={'space-around'} gap={"15px"}>
            <Paper elevation={4}>
              <Card style={{ padding: 10 }}>
                <CardHeader
                  avatar={<SiGmail size={40} color="#ca4343" />}
                  title={
                    <Typography
                      component="span"
                      fontWeight={Constants.defaultFontWeight}
                      fontSize={"1.25rem"}
                    >
                      Mail
                    </Typography>
                  }
                  subheader="Mail Your Question"
                />
                <CardContent>
                  <Box>
                    <a href="mailto:net@pansuriyaimpex.com">net@pansuriyaimpex.com</a>
                  </Box>
                </CardContent>
              </Card>
            </Paper>
            <Paper elevation={4}>
              <Card style={{ padding: 10 }}>
                <CardHeader
                  avatar={<FaBook size={35} color="#ca4343" />}
                  title={
                    <Typography
                      component="span"
                      fontWeight={Constants.defaultFontWeight}
                      fontSize={"1.25rem"}
                    >
                      Documentation
                    </Typography>
                  }
                  subheader="Read Documentation"
                />
                <CardContent>
                  <Box>
                    <a
                      href={Constants.HELP_DOCUMENTATION_URL}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      View Documentation
                    </a>
                  </Box>
                </CardContent>
              </Card>
            </Paper>
            <Paper elevation={4}>
              <Card style={{ padding: 10 }}>
                <CardHeader
                  avatar={<HiOutlineCodeBracket size={35} color="#ca4343" />}
                  title={
                    <Typography
                      component="span"
                      fontWeight={Constants.defaultFontWeight}
                      fontSize={"1.25rem"}
                    >
                      API Documentation
                    </Typography>
                  }
                  subheader="Read API Documentation"
                />
                <CardContent>
                  <Box>
                    <a
                      href={window.location.origin + "/app/help/api"}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      View API Documentation
                    </a>
                  </Box>
                </CardContent>
              </Card>
            </Paper>
          </Box>
        </Box>
      </Box>
    );
  }
}

export default Help;
